<div [ngClass]="{'subBlockContainer': !setFullWindow , 'subBlockContainer_full':setFullWindow} ">
  <div class="pageTitle">
    {{tittle}}
    <i class="material-icons pullfloat-right" (click)="close()">close</i>

  </div>
  <div class="subBlockContent">
    <div class="row">
      <div class="col-md-9">
        <div class="title">
          <label for="postInput" class="postcode-label">WHAT IS THE DELIVERY POSTCODE?</label>
          <div class="searchInputGroup">
            <div class="searchIcon">
              <i class="fas fa-search fa-lg"></i>
            </div>
            <input class="searchInput" type="text" name="postInput" id="postInput">
          </div>

        </div>


        <div id="accordion">
          <div class="card">
            <div class="card-header" id="headingOne">
              <h5 class="mb-0">
                <button class="btn btn-link" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                  <b>Zone 1</b> - Invoice &lt; $300ex =
                  <strong>$10ex Freight</strong>&nbsp;
                  <b>|</b>&nbsp;Invoice &gt; $300ex =
                  <strong>FREE Freight</strong>
                </button>
              </h5>
            </div>

            <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordion">
              <div class="card-body">
                MORE CONTENT WILL COME INSIDE HERE
              </div>
            </div>
          </div>
          <div class="card">
            <div class="card-header" id="headingTwo">
              <h5 class="mb-0">
                <button class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                  <b>Zone 1</b> - Invoice &lt; $300ex =
                  <strong>$10ex Freight</strong>&nbsp;
                  <b>|</b>&nbsp;Invoice &gt; $300ex =
                  <strong>FREE Freight</strong>
                </button>
              </h5>
            </div>
            <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo" data-parent="#accordion">
              <div class="card-body">
                MORE CONTENT WILL COME INSIDE HERE
              </div>
            </div>
          </div>
          <div class="card">
            <div class="card-header" id="headingThree">
              <h5 class="mb-0">
                <button class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                  <b>Zone 1</b> - Invoice &lt; $300ex =
                  <strong>$10ex Freight</strong>&nbsp;
                  <b>|</b>&nbsp;Invoice &gt; $300ex =
                  <strong>FREE Freight</strong>
                </button>
              </h5>
            </div>
            <div id="collapseThree" class="collapse" aria-labelledby="headingThree" data-parent="#accordion">
              <div class="card-body">
                MORE CONTENT WILL COME INSIDE HERE
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-3 freight-policy">

        <h4>Freight Policy </h4>
        Click here to download a copy of the Dicker Data Freight Policy Best effort to deliver same day for Sydney metro orders placed
        before 10am however this is not guaranteed* Certain large or special items will be charged freight regardless of
        zone (e.g. all racks and selected UPS devices & printers) Web orders for Zone 3 or Non Free Freight products will
        be put into a hold status and the reseller will be advised of freight charge Electronic products such as licenses
        and selected warranties do not incur any freight charge Dicker Data Ltd does not charge for orders marked as collect.
        These orders need to be collected between 9AM and 4PM Monday to Friday (excluding public holidays) Special freight
        arrangements can be organised on a case by case basis with each individual account

        <h4>Dicker Data's Drop Ship Policy</h4>
        Dicker Data offers drop shipping services at no additional cost for all of our resellers. Simply enter your customer's address
        when prompted during the check-out process on the website and the order will be directed there instead of your standard
        address. Dicker Data can add your company logo to all delivery paperwork to ensure the delivery appears to have come
        from your company. If you would like your logo added please email a high-resolution copy of your company logo to
        sales@dickerdata.com.au along with your account code. Please mention "Delivery Document Logo" in the body of the
        email and we'll take care of the rest. One of our customer service representatives will email you a proof copy for
        you to approve once the logo has been added.

      </div>
    </div>
  </div>
  <div #entry>


  </div>
